export enum ArticleSliderVariants {
  RECOMMENDATION,
  HISTORY,
}
